import { mdiLoading } from '@mdi/js';
import Icon from '@mdi/react';

export const LoadingComponent = ({parentHeight = '100vh'} : {parentHeight?: string}) => {
  return (
    <div style={{ height: parentHeight }} className="flex justify-center items-center">
        <Icon size={2} path={mdiLoading} className='text-primary' spin />
    </div>
  );
}
